import React from "react";
import { Table, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { injectModels } from "../../../redux/injectModels";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../constants/routes";
import ReactPaginate from "react-paginate";
import { Routes } from "../../../constants";
import { FAQService } from "../../../services";
import { toast } from "react-toastify";
import { handleConsoleError } from "../../../utils/common-methods";

function Faq(props) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  //FAQ LIST
  const getData = async () => {
    props.application.setLoading(true);

    try {
      const res = await FAQService.getFAQList();
      if (res?.isSuccess && res?.data?.length > 0) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  //Edit FAQ
  const handleEdit = async (id) => {
    FAQService.setFaqId(id);
    navigate(Routes.ADMIN_FAQ_EDIT);
  };

  //Add FAQ
  const handleAdd = () => {
    FAQService.removeFaqId(); // Clear previous FAQ ID
    navigate(routes.ADMIN_FAQ_EDIT);
  };

  //DELETE FAQ
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this record?"
    );

    if (!confirmDelete) {
      return; // Exit if the user cancels
    }

    try {
      props.application.setLoading(true);
      const response = await FAQService.DeleteFAQDocument(id);
      if (response?.isSuccess) {
        toast.success("Record deleted successfully");
        getData();
      } else {
        toast.error(response?.message || "Failed to delete the record");
      }
    } catch (error) {
      const message=handleConsoleError(error);
      toast.error(
        error?.message || message
      );
    } finally {
      props.application.setLoading(false);
    }
  };

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };
  return (
    <React.Fragment>
      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">
              {" "}
              <i className="fa-solid fa-chevron-right"></i>FAQ
            </li>
          </ol>
        </nav>
      </div>

      <div className="table-responsive">
        <div className="d-flex justify-content-between mb-2">
          <h2>FAQ</h2>
          <Button variant="primary" onClick={handleAdd}>
            Add FAQ
          </Button>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Question</th>
              <th>Answer</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData && paginatedData.length > 0 ? (
              <React.Fragment>
                {paginatedData.map((item, idx) => {
                  return (
                    <tr key={idx} style={{ verticalAlign: "middle" }}>
                      <td>{calculateSNo(idx)}</td>
                      <td>{item?.question}</td>
                      <td>{item?.answer}</td>
                      <td
                        className="delete-create"
                        style={{ textAlign: "center" }}
                      >
                        {item?.isActive === true ? (
                          <i className="ri-check-fill"></i>
                        ) : (
                          <i className="ri-close-circle-line"></i>
                        )}
                      </td>
                      <td>
                        <div className="delete-create">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              handleEdit(item?.id);
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <i className="ri-pencil-line"></i>
                          </Link>

                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              handleDelete(item?.id);
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <i className="ri-delete-bin-line"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="10 mt-2">No results found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="table-footer">
        <p className="mb-3">
          <strong>Total Count: {filteredData.length}</strong>
        </p>
        {filteredData.length === 0 ? "" : renderPagination()}
      </div>
    </React.Fragment>
  );
}

export default injectModels(["admin", "application"])(Faq);
